<template>
  <el-card
    class="h-full"
    :body-style="{ padding: '20px', height: type === 'repeatAdd' ? '700px' : '100%' }"
  >
    <div v-if="type !== 'repeatAdd'">
      <span class="border-l-3 border-color-primary pl-10px text-18px">权限配置</span>
    </div>
    <div class="mt-10px flex justify-between" v-if="type !== 'repeatAdd'">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" class="flex">
        <el-form-item label="权限有效期至" prop="endTime">
          <el-date-picker
            type="datetime"
            v-model="form.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="申请原因" prop="reason">
          <el-input v-model="form.reason" clearable class="w-400px"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" :loading="saveLoading" @click="submit">提交申请</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </div>
    </div>
    <div><span class="border-l-3 border-color-primary pl-10px text-18px">权限范围</span></div>
    <el-row class="h-300px mt-10px">
      <el-col :span="8" class="border-1px h-full rounded-5px pl-10px pr-10px relative">
        <el-tabs v-model="activeName" class="h-full">
          <el-tab-pane label="角色" name="first" class="h-full">
            <div class="h-full">
              <div class="flex">
                <el-input
                  v-model="searchRole"
                  placeholder="人员姓名/人员编号"
                  size="mini"
                  class="mr-10px"
                  @keyup.enter.native="searchRoleData"
                  clearable
                ></el-input>
                <el-button size="mini" type="primary" @click="searchRoleData">搜索</el-button>
              </div>
              <el-tree
                class="mt-10px h-[calc(100%-58px)] overflow-auto"
                :data="roleTree"
                :props="defaultTreeProps"
                node-key="id"
                show-checkbox
                ref="roleTree"
                lazy
                :load="loadRoleData"
              ></el-tree>
            </div>
          </el-tab-pane>
          <el-tab-pane label="组织机构" name="second" class="h-full">
            <el-tree
              class="h-full overflow-auto"
              :data="groupTree"
              :props="defaultTreeProps"
              node-key="id"
              show-checkbox
              ref="groupTree"
              lazy
              :load="loadGroupData"
            ></el-tree>
          </el-tab-pane>
          <el-tab-pane label="其他" name="third" class="h-full"></el-tab-pane>
        </el-tabs>
        <el-button class="absolute top-8px right-10px" type="primary" size="mini" @click="addAuth"
          >添加</el-button
        >
      </el-col>
      <el-col :span="16" class="h-full pl-20px">
        <el-table v-loading="authLoading" border height="100%" :data="authData">
          <el-table-column type="index" width="55" label="序号"> </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="authDimension"
            label="授权维度"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="authScope"
            label="授权范围"
          ></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="deleteAuth(scope.row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="mt-10px">
      <span v-if="type === 'repeatAdd'" class="border-l-3 border-color-primary pl-10px text-18px"
        >权限配置</span
      >
      <span v-else class="border-l-3 border-color-primary pl-10px text-18px">授权规则</span>
    </div>
    <el-row
      class="mt-10px"
      :class="[type === 'repeatAdd' ? 'h-[calc(100%-400px)]' : 'h-[calc(100%-462px)]']"
    >
      <el-col v-if="type === 'repeatAdd'" :span="8" class="h-full p-10px">
        <div>
          权限有效期至：<el-date-picker
            type="datetime"
            v-model="form.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </div>
        <div>申请原因：</div>
        <el-input v-model="form.reason" clearable type="textarea" :rows="8"></el-input>
      </el-col>
      <el-col v-else :span="8" class="border-1px h-full rounded-5px p-10px">
        <div class="flex">
          <el-input
            v-model="searchClass"
            size="mini"
            placeholder="实体名称/实体表名"
            class="mr-10px"
            @keyup.enter.native="searchClassData"
            clearable
          ></el-input>
          <el-button type="primary" size="mini" @click="searchClassData">搜索</el-button>
          <el-button type="primary" size="mini" @click="addClass">添加</el-button>
        </div>
        <el-table
          v-loading="classLoading"
          height="calc(100% - 76px)"
          class="mt-10px"
          :data="classData"
          @selection-change="selectClass"
          ref="classTable"
          row-key="id"
          lazy
          :load="load"
          :tree-props="{ children: 'children', hasChildren: 'isLeaf' }"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column show-overflow-tooltip prop="name" label="实体名称"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="tableName"
            label="实体表名"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="sourceSystem"
            label="来源系统"
          ></el-table-column>
        </el-table>
        <el-pagination
          class="mt-10px"
          background
          @current-change="classCurrentChange"
          @size-change="classSizeChange"
          :current-page.sync="classPage.pageNo"
          :page-size.sync="classPage.pageSize"
          :page-sizes="$pageSizeAll"
          :pager-count="5"
          layout="->, total, sizes, prev, pager, next"
          :total="classPage.total"
        ></el-pagination>
      </el-col>
      <el-col :span="16" class="h-full pl-20px">
        <div class="flex justify-end">
          <el-button type="primary" size="mini" @click="addAttribute" v-if="type === 'repeatAdd'"
            >添加</el-button
          >
          <el-button type="primary" size="mini" @click="handlerPreview">预览</el-button
          ><el-button type="danger" size="mini" @click="deleteRule">删除</el-button>
        </div>
        <el-table
          v-loading="ruleLoading"
          height="calc(100% - 38px)"
          class="mt-10px"
          :data="ruleData"
          border
          @selection-change="selectRule"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="className"
            label="实体名称"
            v-if="type !== 'repeatAdd'"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="classTableName"
            label="实体表名"
            v-if="type !== 'repeatAdd'"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="code" label="属性编码"></el-table-column>
          <el-table-column show-overflow-tooltip prop="name" label="属性名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="operator" label="授权规则">
            <template slot-scope="scope">
              <div v-for="(item, index) in operatorTypeList" :key="index">
                {{ scope.row.operator === item.value ? item.name : '' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorValue" label="值"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="text-center mt-10px" v-if="type === 'repeatAdd'">
      <el-button size="small" type="primary" @click="submit">提交申请</el-button>
      <el-button @click="closeRepeatAdd" size="small">取消</el-button>
    </div>

    <el-dialog
      title="数据范围控制"
      class="middle-dialog"
      :visible.sync="dialogVisible"
      append-to-body
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <el-table
        v-loading="attributeLoading"
        height="400px"
        class="mt-10px"
        :data="attributeData"
        border
        @selection-change="selectAttribute"
        ref="attributeTable"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column show-overflow-tooltip prop="code" label="属性编码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="属性名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="operator" label="授权规则">
          <template slot-scope="scope">
            <div>
              <el-select
                v-model="scope.row.operator"
                placeholder="请选择授权规则"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in operatorTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="operatorValue" label="值">
          <template slot-scope="scope">
            <div>
              <el-input
                v-model="scope.row.operatorValue"
                placeholder="请输入值"
                clearable
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="tc">
        <el-button size="small" type="primary" @click="confirmOperate">保存</el-button>
        <el-button @click="closeDialog" size="small">取消</el-button>
      </div>
    </el-dialog>
    <!-- 预览 -->
    <el-dialog
      title="数据范围预览"
      class="middle-dialog"
      :visible.sync="previewVisible"
      :close-on-click-modal="true"
      append-to-body
      v-dialogDrag
    >
      <el-table
        v-loading="previewLoading"
        height="400px"
        class="mt-10px"
        :data="previewData"
        border
        ref="previewTable"
      >
        <el-table-column
          v-for="(val, index) in previewHeader"
          :prop="`${val.tableName}.${val.columnName}`"
          sortable="custom"
          show-overflow-tooltip
          :key="index"
          :label="val.name"
          min-width="150"
        >
          <template slot-scope="scope">
            <div class="truncate">
              {{ scope.row[`${val.tableName}.${val.columnName}`] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-10px"
        background
        @current-change="previewCurrentChange"
        @size-change="previewSizeChange"
        :current-page.sync="previewPage.pageNo"
        :page-size.sync="previewPage.pageSize"
        :page-sizes="$pageSizeAll"
        :pager-count="5"
        layout="->, total, sizes, prev, pager, next"
        :total="previewPage.total"
      ></el-pagination>
      <!-- <div slot="footer" class="tc">
        <el-button size="small" type="primary" @click="confirmOperate">保存</el-button>
        <el-button @click="previewVisible = false" size="small">取消</el-button>
      </div> -->
    </el-dialog>
  </el-card>
</template>

<script>
import DataPermissionsService from '@/services/DataPermissionsService'
import stdClassListService from '@/services/stdClassListService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'

export default {
  name: 'authConfig',
  props: ['type', 'classId'],
  data() {
    return {
      form: {
        endTime: '',
        reason: '',
      },
      rules: {
        endTime: [{ required: true, message: '请选择权限有效期至', trigger: 'blur' }],
        reason: [{ required: true, message: '请选择申请原因', trigger: 'blur' }],
      },
      saveLoading: false,
      activeName: 'first',
      searchRole: '',
      roleTree: [],
      groupTree: [],
      selectRoles: [],
      selectGroups: [],
      defaultTreeProps: {
        // 目录树配置选项
        children: 'children',
        label: 'name',
        isLeaf: 'isLeaf',
      },
      authData: [],
      authLoading: false,
      searchClass: '',
      classData: [],
      classLoading: false,
      classPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      ruleData: [],
      ruleLoading: false,
      dialogVisible: false,
      attributeData: [],
      attributeLoading: false,
      selectAttributeData: [],
      selectClassData: [],
      operatorTypeList: [],
      selectRuleData: [],
      dimensionTypeList: [],
      previewVisible: false,
      previewPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      previewLoading: false,
      previewData: [],
      previewHeader: [],
    }
  },
  async created() {
    await this.getDimensionType()
    this.getRoleList()
    if (this.type !== 'repeatAdd') {
      this.searchClassData()
    }
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'first') {
        this.getRoleList()
      } else if (newVal === 'second') {
        this.getDeptList()
      }
    },
  },
  methods: {
    // 获取维度类型
    async getDimensionType() {
      const res = await DataPermissionsService.getDimensionType()
      if (res) {
        this.dimensionTypeList = res
      }
    },
    // 获取角色列表(角色只有一级)
    async getRoleList() {
      const res = await DataPermissionsService.getRoleList()
      if (res) {
        const roleOne = _.find(this.dimensionTypeList, { name: '角色' })
        this.roleTree = _.map(res, (item) => {
          item.children = []
          item.dimensionType = roleOne.value
          item.dimensionName = roleOne.name
          return item
        })
      }
    },
    // 懒加载用户(角色下的用户)
    async loadRoleData(node, resolve) {
      if (node.data.id) {
        const res = await this.getUserList({ roleId: node.data.id })
        return resolve(res)
      }
      return false
    },
    // 角色关键字搜索
    async searchRoleData() {
      if (this.searchRole) {
        this.roleTree = await this.getUserList({ userName: this.searchRole })
      } else {
        this.getRoleList()
      }
    },
    // 获取用户列表
    async getUserList(params) {
      let res = await DataPermissionsService.getUserList(params)
      if (res) {
        const userOne = _.find(this.dimensionTypeList, { name: '用户' })
        res = res.map((item) => {
          item.isLeaf = true
          item.dimensionType = userOne.value
          item.dimensionName = userOne.name
          return item
        })
        return res
      }
      return []
    },
    // 获取部门列表
    async getDeptList() {
      const res = await DataPermissionsService.getDeptList()
      if (res) {
        const deptOne = _.find(this.dimensionTypeList, { name: '部门' })
        this.groupTree = _.map(res, (item) => {
          item.dimensionType = deptOne.value
          item.dimensionName = deptOne.name
          return item
        })
      }
    },
    // 懒加载用户（组织机构下的用户）
    async loadGroupData(node, resolve) {
      if (node.data.children && node.data.children.length > 0) {
        let res = node.data.children
        const deptOne = _.find(this.dimensionTypeList, { name: '部门' })
        res = _.map(res, (item) => {
          item.dimensionType = deptOne.value
          item.dimensionName = deptOne.name
          return item
        })
        return resolve(res)
      }
      if (node.data.children && node.data.children.length === 0) {
        const res = await this.getUserList({ deptId: node.data.id })
        return resolve(res)
      }
      return false
    },
    // 懒加载子节点
    load(tree, treeNode, resolve) {
      if (treeNode.level === 0 || treeNode.level === '') {
        this.getClassData(tree.id, resolve)
        return resolve([])
      }
      return false
    },
    // 搜索实体
    searchClassData() {
      this.getClassData()
    },
    async getClassData(parentId, resolve) {
      this.classLoading = true
      if (this.searchClass !== '' && this.searchClass !== null) {
        this.classPage.pageNo = 1
      }
      const parameter = {
        keyword: this.searchClass,
        pageno: this.classPage.pageNo,
        pagesize: this.classPage.pageSize,
        data_type: this.searchClass ? 1 : 0,
        parent_id: parentId,
        standard_id: this.$route.query.standardId,
      }
      const res = await stdClassListService.getClassList(parameter)
      this.classLoading = false
      if (res && res.code === 0 && res.data) {
        if (parentId) {
          resolve(res.data)
        } else {
          this.classData = res.data
          this.$nextTick(() => {
            this.$refs.classTable.doLayout()
          })
          if (res.page) {
            this.classPage.total = res.page.recordCount
          }
        }
      }
    },
    classCurrentChange(num) {
      this.classPage.pageNo = num
      this.searchClassData()
    },
    classSizeChange(size) {
      this.classPage.pageSize = size
      this.searchClassData()
    },
    // 添加实体
    async addClass() {
      if (this.selectClassData.length > 1) {
        this.$message.info('一次只能选择一个实体')
      } else if (this.selectClassData.length === 1) {
        this.dialogVisible = true
        await this.getAttributeList(this.selectClassData[0].id)
        await this.getOperatorType()
        this.$refs.classTable.clearSelection()
      } else {
        this.$message.info('请选择要添加的实体')
      }
      // 数据范围控制表格添加反显
      this.attributeData = this.attributeData.map((item) => {
        this.ruleData.forEach((val) => {
          if (item.id === val.id) {
            item = { ...val }
          }
        })
        return item
      })
    },
    // 添加属性
    addAttribute() {
      this.dialogVisible = true
      this.getAttributeList(this.classId)
      this.getOperatorType()
      this.$refs.classTable.clearSelection()
    },
    // 获取实体属性
    async getAttributeList(id) {
      this.attributeLoading = true
      const parameter = {
        class_id: id,
        pageno: 1,
        pagesize: 999,
        is_all: true,
      }
      this.attributeLoading = false
      const res = await stdClassListService.getAttrList(parameter)
      if (res && res.code === 0) {
        this.attributeData = res.data
      }
    },
    // 获取授权规则
    async getOperatorType() {
      const res = await DataPermissionsService.getOperatorType()
      if (res && res.code === 0) {
        this.operatorTypeList = res.data
      }
    },
    closeDialog() {
      this.$refs.attributeTable.clearSelection()
      this.selectAttributeData = []
      this.dialogVisible = false
    },
    // 添加授权规则保存
    confirmOperate() {
      // 只要有值，没勾选的属性也要保存进去
      this.attributeData.forEach((item) => {
        // eslint-disable-next-line no-prototype-builtins
        if ((item.hasOwnProperty('operator') && item.operator !== null) || item.operatorValue) {
          this.selectAttributeData.push(item)
        }
      })
      if (this.selectAttributeData.length) {
        // 判断是新增进去还是替换掉原来的
        const map = {}
        this.ruleData.forEach((item, index) => {
          map[item.id] = index
        })
        this.selectAttributeData.forEach((item) => {
          const index = map[item.id]
          if (index !== undefined) {
            this.ruleData[index] = { ...item }
            this.ruleData = this.ruleData.slice(0) // 立马更新数值
          } else {
            this.ruleData.push(item)
          }
        })
        // this.ruleData = this.ruleData.concat(this.selectAttributeData)
        this.closeDialog()
      } else {
        this.$message.info('请选择要添加的属性')
      }
    },
    selectAttribute(val) {
      this.selectAttributeData = _.cloneDeep(val)
    },
    selectClass(val) {
      this.selectClassData = _.cloneDeep(val)
    },
    // 添加授权
    addAuth() {
      if (this.activeName === 'first') {
        let selectData = this.$refs.roleTree.getCheckedNodes()
        if (selectData.length) {
          const idList = _.map(this.selectRoles, (item) => {
            return item.id
          })
          selectData = selectData.filter((item) => {
            return !_.includes(idList, item.id)
          })
          this.selectRoles = this.selectRoles.concat(selectData)
          const authData = []
          _.map(selectData, (item) => {
            authData.push({
              authDimension: item.dimensionName,
              authScope: item.name,
              type: 'role',
              authorizationDimensionType: item.dimensionType,
              authorizationDimensionId: item.id,
            })
          })
          this.authData = this.authData.concat(authData)
        } else {
          this.$message.info('请选择要添加的角色')
        }
      } else if (this.activeName === 'second') {
        let selectData = this.$refs.groupTree.getCheckedNodes()
        if (selectData.length) {
          const idList = _.map(this.selectGroups, (item) => {
            return item.id
          })
          selectData = selectData.filter((item) => {
            return !_.includes(idList, item.id)
          })
          this.selectGroups = this.selectGroups.concat(selectData)
          const authData = []
          _.map(selectData, (item) => {
            authData.push({
              authDimension: item.dimensionName,
              authScope: item.name,
              type: 'group',
              authorizationDimensionType: item.dimensionType,
              authorizationDimensionId: item.id,
            })
          })
          this.authData = this.authData.concat(authData)
        } else {
          this.$message.info('请选择要添加的组织机构')
        }
      }
    },
    // 移除授权
    deleteAuth(row) {
      if (row.type === 'role') {
        const unSelect = this.selectRoles.filter((item) => {
          return row.authorizationDimensionId === item.id
        })
        _.map(unSelect, (item) => {
          this.$refs.roleTree.setChecked(item, false)
        })
        this.selectRoles = this.selectRoles.filter((item) => {
          return row.authorizationDimensionId !== item.id
        })
      } else if (row.type === 'group') {
        const unSelect = this.selectGroups.filter((item) => {
          return row.authorizationDimensionId === item.id
        })
        _.map(unSelect, (item) => {
          this.$refs.groupTree.setChecked(item, false)
        })
        this.selectGroups = this.selectGroups.filter((item) => {
          return row.authorizationDimensionId !== item.id
        })
      }
      this.authData = _.differenceWith(this.authData, [row], _.isEqual)
    },
    // 删除授权规则
    deleteRule() {
      if (this.selectRuleData.length) {
        this.ruleData = _.differenceWith(this.ruleData, this.selectRuleData, _.isEqual)
      } else {
        this.$message.info('请选择要删除的数据')
      }
    },
    selectRule(val) {
      this.selectRuleData = _.cloneDeep(val)
    },
    // 提交
    async submit() {
      const authorizationDimensionClassRelationList = []
      _.map(this.authData, (item) => {
        authorizationDimensionClassRelationList.push({
          authorizationDimensionId: item.authorizationDimensionId,
          authorizationDimensionType: item.authorizationDimensionType,
        })
      })
      const authorizationClassAtributeRules = []
      let classIds = []
      _.map(this.ruleData, (item) => {
        authorizationClassAtributeRules.push({
          classAttributeId: item.id,
          classId: item.classId,
          operator: item.operator,
          operatorValue: item.operatorValue,
        })
        classIds.push(item.classId)
      })
      classIds = _.uniq(classIds)
      this.saveLoading = true
      const res = await DataPermissionsService.create({
        endTime: this.form.endTime,
        reason: this.form.reason,
        authorizationDimensionClassRelationList,
        authorizationClassAtributeRules,
        classIds: this.type === 'repeatAdd' ? [this.classId] : classIds,
      })
      this.saveLoading = false
      if (!res.message) {
        this.$message.success('保存成功')
        if (this.type === 'repeatAdd') {
          this.closeRepeatAdd()
        } else {
          this.$router.go(-1)
        }
      }
    },
    handlerPreview() {
      if (this.selectRuleData.length > 1) {
        this.$message.info('一次只能选择一个实体')
      } else if (this.selectRuleData.length === 1) {
        this.previewVisible = true
        this.getDynamicTableHeader()
        this.getPreviewData()
      } else {
        this.$message.info('请选择要预览的实体')
      }
    },
    // 获取实体数据动态表头
    async getDynamicTableHeader() {
      const res = await stdClassDataService.getDynamicTableHeader({
        classId: this.selectRuleData[0].classId,
      })
      if (res && res.code === 0 && res.data) {
        this.previewHeader = res.data
      }
    },
    getValueTypeName(type) {
      switch (type) {
        case 1:
          return 'string'
        case 2:
          return 'int'
        case 3:
          return 'float'
        case 7 || 8:
          return 'DateTime'
        default:
          return 'string'
      }
    },
    // 获取预览数据
    async getPreviewData() {
      this.previewLoading = true
      const conditionalModelsList = []
      this.ruleData.forEach((item) => {
        conditionalModelsList.push({
          fieldName: `${item.classTableName}.${item.columnName}`,
          fieldValue: item.operatorValue,
          conditionalType: item.valueType,
          cSharpTypeName: this.getValueTypeName(item.valueType),
        })
      })
      const res = await stdClassDataService.getDynamicTableData({
        classId: this.selectRuleData[0].classId,
        skipCount: (this.previewPage.pageNo - 1) * this.previewPage.pageSize,
        maxResultCount: this.previewPage.pageSize,
        conditionalModels: conditionalModelsList,
      })

      this.previewLoading = false
      if (res && res.code === 0 && res.data) {
        this.previewData = res.data
        this.previewPage.total = res.totalCount
        this.$nextTick(() => {
          if (this.$refs.previewTable) {
            this.$refs.previewTable.doLayout()
          }
        })
      }
    },
    previewCurrentChange(num) {
      this.previewPage.pageNo = num
      this.getPreviewData()
    },
    previewSizeChange(size) {
      this.previewPage.pageSize = size
      this.getPreviewData()
    },
    closeRepeatAdd() {
      this.$emit('closeRepeatAdd')
    },
  },
}
</script>

<style lang="scss" scoped>

/deep/.el-tabs__content {
  height: calc(100% - 60px) !important;
}
/deep/.el-input--mini .el-input__inner {
  height: 28px !important;
}
/deep/.el-form-item {
  margin-bottom: 10px !important;
}

</style>
